import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { PersonIcon } from '../icons';
import { UsernameIconContainer, LocationSection } from './index';
import { getOptionStyles, getOptionDetailsStyles } from '../helpers';

const AutocompleteOption = ({
  option,
  isSelected,
  isFirstOption,
  displayName,
  displayRole,
  locationString,
  shouldShowDocId,
  shouldShowLocation,
  showDisplayNamesOnly,
}) => {
  const containerStyles = getOptionStyles(isSelected, isFirstOption);
  const detailsStyles = getOptionDetailsStyles();

  const handleMouseEnter = (e) => {
    e.currentTarget.style.backgroundColor = '#F3E8FF';
  };

  const handleMouseLeave = (e) => {
    if (!isSelected) {
      e.currentTarget.style.backgroundColor = 'transparent';
    }
  };

  return (
    <Box
      component="li"
      style={containerStyles}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <UsernameIconContainer
        icon={<PersonIcon role={displayRole} />}
        text={option.username || displayName}
        showDivider={!!option.username}
      />
      {!showDisplayNamesOnly && (
        <>
          <Typography style={detailsStyles}>
            {displayName}
            {shouldShowDocId && ` | DOC ID: ${option.docId}`}
            {' | '}
            {displayRole}
          </Typography>
          {shouldShowLocation && (
            <LocationSection text={locationString} />
          )}
        </>
      )}
    </Box>
  );
};

export default AutocompleteOption;

